import React from "react"

const MultiMapEmbed = ({ query, loading = "lazy" }) => {
  return (
    <iframe
      src={`https://www.google.com/maps/d/embed?mid=12LBxR-0xUvo967woHgLERCkQ7Pv4SzM&ehbc=2E312F`}
      width="600"
      height="450"
      style={{ border: "none" }}
      allowfullscreen=""
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
  )
}

export default MultiMapEmbed
